import React, { useState } from 'react';
import { Button } from '@lifepal/lifepal-design-system';
import classNames from 'classnames';
import dynamic from 'next/dynamic';

import styles from './Summary.module.scss';
import { GTM_CLASS } from '../../lib/constant';

interface SummaryProps {
  content: string | JSX.Element | JSX.Element[];
  variant?: 'grey' | 'blue' | 'blue-button';
  categorySlug: string;
}

const Summary = (props: SummaryProps) => {
  const { content, variant, categorySlug } = props;
  const [summaryPopup, setSummaryPopup] = useState(false);
  const leadFormSummaryModalView = () => {
    const LeadFormSummaryModal = dynamic(
      () => import('../modal/LeadFormSummaryModal/LeadFormSummaryModal'),
    );

    return (
      <LeadFormSummaryModal
        closePopup={() => setSummaryPopup(false)}
        gtmClass={GTM_CLASS.OPEN_LEADFORM_BLUE_CTA_POPUP}
        categorySlug={categorySlug}
      />
    );
  };

  return (
    <div
      className={classNames(styles.summary__wrapper, [
        variant && variant === 'grey' ? styles.summary__wrapper_grey : '',
      ])}
    >
      {variant && variant === 'grey' ? (
        <div className={styles.summary__wrapper_grey_vline}></div>
      ) : (
        <></>
      )}
      <div
        className={
          variant
            ? variant !== 'blue'
              ? variant === 'grey'
                ? styles.content_grey
                : styles.content_blue_button
              : styles.content
            : styles.content
        }
      >
        <div
          className={classNames(styles.summary__wrapper_content, [
            variant && variant === 'blue-button' && styles.summary__wrapper_content_wrapper,
          ])}
        >
          <span
            className={
              variant && variant === 'blue-button' ? styles.summary__wrapper_content_blue_button : ""
            }
          >
            {content}
          </span>
          {variant && variant === 'blue-button' ? (
            <div className={styles.summary__wrapper_btn}>
              {summaryPopup && leadFormSummaryModalView()}
              <Button
                variant="ghost"
                size="md"
                isBlock={false}
                onClick={() => {
                  setSummaryPopup(true);
                }}
              >
                Lihat
              </Button>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default Summary;
